export var FiscalInvoiceType;
(function (FiscalInvoiceType) {
    FiscalInvoiceType["Normal"] = "Normal";
    FiscalInvoiceType["ProForma"] = "ProForma";
    FiscalInvoiceType["Copy"] = "Copy";
    FiscalInvoiceType["Training"] = "Training";
    FiscalInvoiceType["Advance"] = "Advance";
})(FiscalInvoiceType || (FiscalInvoiceType = {}));
export var FiscalTransactionType;
(function (FiscalTransactionType) {
    FiscalTransactionType["Sale"] = "Sale";
    FiscalTransactionType["Refund"] = "Refund";
})(FiscalTransactionType || (FiscalTransactionType = {}));
export var FiscalPaymentType;
(function (FiscalPaymentType) {
    FiscalPaymentType["Other"] = "Other";
    FiscalPaymentType["Cash"] = "Cash";
    FiscalPaymentType["Card"] = "Card";
    FiscalPaymentType["Check"] = "Check";
    FiscalPaymentType["WireTransfer"] = "WireTransfer";
    FiscalPaymentType["Voucher"] = "Voucher";
    FiscalPaymentType["MobileMoney"] = "MobileMoney";
})(FiscalPaymentType || (FiscalPaymentType = {}));
export var FiscalTransactionExtensionType;
(function (FiscalTransactionExtensionType) {
    FiscalTransactionExtensionType["NormalSale"] = "NS";
    FiscalTransactionExtensionType["ProformaSale"] = "PS";
    FiscalTransactionExtensionType["CopySale"] = "CS";
    FiscalTransactionExtensionType["TrainingSale"] = "TS";
    FiscalTransactionExtensionType["AdvanceSale"] = "AS";
    FiscalTransactionExtensionType["NormalRefund"] = "NR";
    FiscalTransactionExtensionType["ProformaRefund"] = "PR";
    FiscalTransactionExtensionType["CopyRefund"] = "CR";
    FiscalTransactionExtensionType["TrainingRefund"] = "TR";
    FiscalTransactionExtensionType["AdvanceRefund"] = "AR";
})(FiscalTransactionExtensionType || (FiscalTransactionExtensionType = {}));
export var FiscalTaxCategoryType;
(function (FiscalTaxCategoryType) {
    FiscalTaxCategoryType[FiscalTaxCategoryType["TaxOnNet"] = 0] = "TaxOnNet";
    FiscalTaxCategoryType[FiscalTaxCategoryType["TaxOnTotal"] = 1] = "TaxOnTotal";
    FiscalTaxCategoryType[FiscalTaxCategoryType["AmountPerQuantity"] = 2] = "AmountPerQuantity";
})(FiscalTaxCategoryType || (FiscalTaxCategoryType = {}));
export var FiscalStatusAndErrorCodesType;
(function (FiscalStatusAndErrorCodesType) {
    FiscalStatusAndErrorCodesType["AllOk"] = "0000";
    FiscalStatusAndErrorCodesType["PinOk"] = "0100";
    FiscalStatusAndErrorCodesType["StorageAlmostFull"] = "1100";
    FiscalStatusAndErrorCodesType["SmartCardNotPresent"] = "1300";
    FiscalStatusAndErrorCodesType["AuditRequired"] = "1400";
    FiscalStatusAndErrorCodesType["PinCodeRequired"] = "1500";
    FiscalStatusAndErrorCodesType["PinNotOk"] = "2100";
    FiscalStatusAndErrorCodesType["InternetAvailable"] = "0210";
    FiscalStatusAndErrorCodesType["InternetUnavailable"] = "0220";
    FiscalStatusAndErrorCodesType["CardLocked"] = "2110";
    FiscalStatusAndErrorCodesType["SELocked"] = "2210";
    FiscalStatusAndErrorCodesType["SECommunicationFailed"] = "2220";
    FiscalStatusAndErrorCodesType["SEProtocolMissmatch"] = "2230";
    FiscalStatusAndErrorCodesType["InvalidTaxLabels"] = "2310";
    FiscalStatusAndErrorCodesType["NotConfigured"] = "2400";
    FiscalStatusAndErrorCodesType["FieldRequired"] = "2800";
    FiscalStatusAndErrorCodesType["FieldValueTooLong"] = "2801";
    FiscalStatusAndErrorCodesType["FieldValueTooShort"] = "2802";
    FiscalStatusAndErrorCodesType["InvalidFieldLength"] = "2803";
    FiscalStatusAndErrorCodesType["FieldOutOfRange"] = "2804";
    FiscalStatusAndErrorCodesType["InvalidFieldValue"] = "2805";
    FiscalStatusAndErrorCodesType["InvalidDataFormat"] = "2806";
    FiscalStatusAndErrorCodesType["ListTooShort"] = "2807";
    FiscalStatusAndErrorCodesType["SecureMessagingNotSupported"] = "6882";
    //Custom Error Codes
    FiscalStatusAndErrorCodesType["LicenseNotValid"] = "4230";
    FiscalStatusAndErrorCodesType["DuplicatedInvoiceRequest"] = "4242";
})(FiscalStatusAndErrorCodesType || (FiscalStatusAndErrorCodesType = {}));
//# sourceMappingURL=defFiscal.js.map